import React, { useState, Component } from 'react';
import { connect } from 'react-redux'
import * as actions from '@/models/orders/actions'
import cn from 'classnames';
import { Modal, Form, Button, Select, Input, Popconfirm, Radio, InputNumber } from 'antd';
import styles from './style.module.less';

const reasonList = [
  {
    groupName: '商家原因',
    list: [
      '价格不合适',
      '客户原因取消工单',
      '上门时间不合适',
    ]
  },
  {
    groupName: '师傅原因',
    list: [
      '本人技术原因无法完成',
      '与客户要求时间不符',
      '太远去不了',
    ]
  },
  '其他原因'
]

@connect(null, dispatch => ({
  closeOrder(id, params) {
    dispatch(actions.tenantCloseOrder(id, params))
  }
}))
@Form.create()
class TenantCancelOrderForm extends Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      const reason = values.cancel_type + ' - ' + values.cancel_memo
      this.props.closeOrder(this.props.order.get('_id'), {
        reason,
      })
      this.props.requestCancel()
    });
  }

  render() {
    const { order } = this.props
    const { getFieldDecorator, validateFields, getFieldValue } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    return (
      <Form {...formItemLayout} className={styles.form}>
        <Form.Item label="取消理由" required width={120}>
          {getFieldDecorator('cancel_type', {
            rules: [
              {
                required: true,
                message: '请选择取消理由',
              },
            ],
          })(
            <Select>
              {
                reasonList.map(reason => {
                  if (reason.groupName && reason.list) {
                    return (
                      <Select.OptGroup key={reason.groupName} label={reason.groupName}>
                        {
                          reason.list.map(reason => (
                            <Select.Option key={reason} value={reason}>{reason}</Select.Option>
                          ))
                        }
                      </Select.OptGroup>
                    )
                  }

                  return <Select.Option key={reason} value={reason}>{reason}</Select.Option>
                })
              }
            </Select>
          )}
        </Form.Item>
        <Form.Item label="取消详情描述">
          {getFieldDecorator('cancel_memo', {
            rules: [
              {
                required: true,
                message: '请输入描述',
              },
            ],
          })(
            <Input.TextArea></Input.TextArea>
          )}
        </Form.Item>
        <Form.Item
          wrapperCol={{ span: 18, offset: 6 }}
          className={styles.footer}
          extra="请谨慎操作，取消后不可恢复">
          <Popconfirm
            title="此操作不可恢复，确定要取消?"
            onConfirm={this.handleSubmit}
            onCancel={this.props.requestCancel}
            okText="确认"
            cancelText="放弃">
            <Button type="primary">取消工单</Button>
          </Popconfirm>
        </Form.Item>
      </Form>
    );
  }
}

export default function TenantCancelOrder({
  children,
  order
}) {
  const [showDialog, toggleDialog] = useState(false);

  return (
    <React.Fragment>
      {
        React.isValidElement(children) && React.cloneElement(children, {
          onClick: toggleDialog,
        })
      }
      <Modal
        title="取消工单"
        destroyOnClose
        footer={null}
        width={500}
        visible={!!showDialog}
        onCancel={() => toggleDialog(false)}>
          <TenantCancelOrderForm
            order={order}
            requestCancel={() => toggleDialog(false)} />
      </Modal>
    </React.Fragment>
  );
}
